export const VIEW_MODE_KEY = 'trainingDataViewMode';

export enum ViewMode {
  Row = 'row',
  Normal = 'normal',
  Compact = 'compact',
}
